const OfferEvaluationViewMode = {
    POSITION: "POSITION",
    SUPPLIER: "SUPPLIER"
}

export default OfferEvaluationViewMode;